import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CreateProfileBloggerDialogData, CreateProfileBloggerParams} from "../types/create-profile-blogger-modal.types";
import {
  createProfileBloggerModalName,
  createProfilesBloggerFormFields
} from "../configs/create-profile-blogger-modal-config";
import {BloggerModalService} from "../services/blogger-modal.service";
import {RecordData} from "../../../../types/records-table.types";

@Component({
  selector: 'app-create-profile-blogger-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule
  ],
  templateUrl: './create-profile-blogger-modal.component.html',
  styleUrl: './create-profile-blogger-modal.component.scss'
})
export class CreateProfileBloggerModalComponent extends BaseModalComponent {
  private dialogData = inject<CreateProfileBloggerDialogData>(MAT_DIALOG_DATA);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);

  public readonly createProfilesBloggerFormFields = createProfilesBloggerFormFields;
  public formGroup: FormGroup = new FormGroup({});

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(createProfileBloggerModalName);
    this.initForm();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(createProfileBloggerModalName);
  }

  public isValid(): boolean {
    return !!this.formGroup.get('url' as string)?.value;
  }

  public async handleProfileBloggerCreate(): Promise<void> {
    const createProfileBloggerParams: CreateProfileBloggerParams = {
      bloggerId: Number((this.dialogData.recordData['blogger'] as RecordData).id),
      url: this.formGroup.get('url' as string)?.value
    };

    await this.bloggerModalService.createProfileBlogger(createProfileBloggerParams);

    this.closeDialog('cancel');
  }

  private initForm(): void {
    const fieldNames: Array<string> = this.createProfilesBloggerFormFields.map(field => field.fieldName);
    this.formGroup = this.baseModalService.initForm(fieldNames);
  }
}
